define('uikit/collections/grid',['require','exports','module','underscore','../channel','./container','../extra/size'],function(require, exports, module){
  var _ = require('underscore');
  var channel = require('../channel');
  var ContainerView = require('./container');
  var Size = require('../extra/size');

  function appendView(view, options) {
    options = options || {};
    if (view instanceof GridRow) {
      this.$el.append(view.$el);
      return this;
    }

    var div = $(document.createElement('div'))
        .toggleClass(options.floated + ' floated', !!options.floated)
        .toggleClass(options.align + ' aligned', !!options.align)
        .toggleClass(options.wide + ' wide', !!options.wide)
        .addClass('column')
        .append(view.$el);

    this.$el.append(div);

    return this;
  };

  var GridRow = ContainerView.extend({

    className: 'row',

    updateAttributes: function() {
      var size = this.getOption('size') ? Grid.getSizeClass(this.getOption('size')) : Grid.getSizeClass(this._views.length);

      this.addClass(this.sizeClass(size), !!size)
          .addClass('centered', this.getBoolOption('centered'));
          // .addClass('compact', this.getBoolOption('compact'))
          // .addClass('fitted', this.getBoolOption('fitted'))
          // .addClass('doubling', this.getBoolOption('doubling'))
          // .addClass('stackable', this.getBoolOption('stackable'))
    },

    appendView: appendView,

    sizeClass: function(size) {
      return size + ' column';
    }

  });

  var Grid = ContainerView.extend({

    className: 'ui grid',

    options: {
      visible: true,
      evenSizes: true,
      size: null,
      compact: false,
      fitted: false,
      padded: false,
      doubling: false,
      stackable: false
    },

    sizeOptionValues: _.values(Size),

    forceUpdate: { evenSizes: true },

    updateAttributes: function() {
      var size = this.getOption('size') ? Grid.getSizeClass(this.getOption('size')) : Grid.getSizeClass(this._views.length);

      this.addClass(this.sizeClass(size), !!size && this.getBoolOption('evenSizes'))
          .addClass('compact', this.getBoolOption('compact'))
          .addClass('fitted', this.getBoolOption('fitted'))
          .addClass('padded', this.getBoolOption('padded'))
          .addClass('doubling', this.getBoolOption('doubling'))
          .addClass('stackable', this.getBoolOption('stackable'))
          .addClass('centered', this.getBoolOption('centered'));
    },

    sizeClass: function(size) {
      return size + ' column';
    },

    appendView: appendView,

    onBeforeRemove: function(view) {
      view.$el.parent().detach();
    }

  });

  Grid.getSizeClass = function(len) {
    var sizes = ['', 'one', 'two', 'three',  'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen']
    var size = sizes[len] || '';
    if (_.isString(len) && !size) {
      // the string value was passed in
      // so just use that
      size = len;
    }
    return size;
  }

  Grid.Row = GridRow;

  channel.reply('grid', function() {
    return Grid;
  });

  module.exports = Grid;
});
